import type { Root } from 'react-dom/client';
import { monterApp } from './index.js';

/** Partie de `import.meta.env` (Vite) que la coquille lit. `DEV` vaut `false` dans tout build de production. */
export interface EnvironnementVite {
  DEV?: boolean;
  VITE_LAKOU_MOCKS?: string;
}

/**
 * Le mode mock n’existe qu’en développement, et seulement avec `VITE_LAKOU_MOCKS=1`. Un build de production n’affiche
 * jamais de session fictive, même si le drapeau a traîné dans l’environnement de construction.
 */
export const modeMocks = (env: EnvironnementVite): boolean => env.DEV === true && env.VITE_LAKOU_MOCKS === '1';

/** Appelé par `main.tsx` (RFC-050) : `monterDepuisEnvironnement(cible, import.meta.env)`. */
export const monterDepuisEnvironnement = (element: HTMLElement, env: EnvironnementVite): Root =>
  monterApp(element, { mocks: modeMocks(env) });
